import { PropertyUnitCategoryModel } from '@/models/property-unit-category';
import { PropertyUnitCategory } from '../types/property-unit-category';

export function transformPropertyUnitCategory(propertyUnitCategory: PropertyUnitCategory): PropertyUnitCategoryModel {
  return {
    name: propertyUnitCategory.name,
  };
}

export function transformPropertyUnitCategories(propertyUnitCategories: PropertyUnitCategory[]): PropertyUnitCategoryModel[] {
  return propertyUnitCategories.map(transformPropertyUnitCategory);
}
